"use client";

import * as React from "react";
import type { ConverterPageContextType } from "types/converter";

export const ConverterPageContext =
  React.createContext<ConverterPageContextType>({
    assetPrice: {
      symbol: "",
      from: "",
      to: "",
      fromDisplayName: "",
      toDisplayName: "",
      "24hrMin": "",
      "24hrMax": "",
      "24hrDelta": "",
      "24hrPercentDelta": "",
      rangeDelta: "",
      rangePercentDelta: "",
      range: [],
      bid: "",
      ask: "",
      marketCap: {
        currency: "",
        value: ""
      },
      supply: {
        currency: "",
        value: ""
      },
      allTimeHigh: {
        currency: "",
        value: ""
      },
      volume: {
        currency: "",
        value: ""
      },
      instantMarketOpen: false,
      limitOrderOpen: false,
      stopLimitOrderOpen: false,
      priceInputDecimals: 0,
      isSyntheticPair: false,
      isPerpPair: false,
      lastTradePrice: ""
    },
    baseSlug: "",
    quoteSlug: "",
    decoratedCoinRelatedPosts: [],
    isRouting: false
  });

export const ConverterPageProvider = ({
  children,
  value
}: {
  children: React.ReactNode;
  value: ConverterPageContextType;
}) => {
  return (
    <ConverterPageContext.Provider value={value}>
      {children}
    </ConverterPageContext.Provider>
  );
};

export const useConverterPageContext = () => {
  const context = React.useContext(ConverterPageContext);

  if (context === undefined) {
    throw new Error(
      "useConverterPageContext must be used within a ConverterPageContext provider"
    );
  }
  return context;
};
